module.exports = __webpack_public_path__ + "static/media/shop.b348042f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/assets/images/school_money/guide/shop.svg
// module id = 595
// module chunks = 0